export default __webpack_public_path__ + "static/media/icon_book.3f51ab96.svg";